// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608121559/js/" + chunkId + "." + {"44":"1619d84b","225":"97d179db","481":"7ff3dab6","486":"a6328b4a","770":"8ef23b68"}[chunkId] + ".0.6181377899080975.chunk.js";
};